

































import * as _ from 'lodash';
import {Vue, Component} from 'vue-property-decorator';
import {Mutation, Getter, namespace} from 'vuex-class';
import {Filters} from '../filters/filters';
import {previewImage, isImage} from '../../util/util';

interface DragDropEvent extends Event {
  dataTransfer: DataTransfer;
}

const ImageFilterMutation = namespace('imageFilter', Mutation);
const ImageFilterGetter = namespace('imageFilter', Getter);

// TODO: utilize custom directive when changing <img> to <canvas>
// for better filter application.

// @Component({
//   directives: {
//     drawImage(canvas: any, binding: any) {
//       const image = new Image();
//       image.onload = () => {
//         canvas.width = image.naturalWidth;
//         canvas.height = image.naturalHeight;

//         const context = canvas.getContext('2d');
//         context!.clearRect(0, 0, canvas.width, canvas.height);

//         const filter = binding.value.imageFilter || 'none';
//         context!.filter = filter;
//         context!.drawImage(image, 0, 0);
//       };
//       image.setAttribute('src', binding.value.currentImage);
//     },
//     applyFilter(canvas: any, binding: any) {
//       const image = new Image();
//       image.onload = () => {
//         canvas.width = image.naturalWidth;
//         canvas.height = image.naturalHeight;

//         const context = canvas.getContext('2d');
//         context!.clearRect(0, 0, canvas.width, canvas.height);

//         const filter = binding.value.imageFilter || 'none';
//         context!.filter = filter;
//         context!.drawImage(image, 0, 0);
//       };
//       image.setAttribute('src', binding.value.currentImage);
//     }
//   }
// })
@Component
export default class ImageViewer extends Vue {
  public $refs: {
    fileform: HTMLFormElement,
  };

  private dragEvents = Object.freeze([
    'drag',
    'dragstart',
    'dragend',
    'dragover',
    'dragenter',
    'dragleave',
    'drop',
  ]);
  private dragAndDropAvailable: boolean = this.isDragAndDropAvailable();

  private currentImageName: string = '';
  private currentImage: string = '';

  private imageFilter: string = '';

  @ImageFilterMutation('selectImage') private selectImage: (image: File) => void;
  @ImageFilterMutation('addImage') private addImage: (file: File) => void;
  @ImageFilterGetter('filters') private filters: {[key: string]: Filters};

  private mounted() {
    if (this.dragAndDropAvailable) {
      _.each(this.dragEvents, (event: string) => {
        this.$refs.fileform.addEventListener(event, ((e: DragDropEvent) => {
          e.preventDefault();
          e.stopPropagation();
        }) as EventListener, false);
      });

      this.$refs.fileform.addEventListener('drop', (e: DragDropEvent) => {
        const droppedFiles = e.dataTransfer.files;

        if (!this.currentImage) {
          this.selectImage(droppedFiles[0]);
        }

        _.each(droppedFiles, (file) => this.addImage(file));
      });
    }

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'imageFilter/selectImage') {
        this.displayImage(mutation.payload);
        this.applyFilters();
      }

      if (mutation.type === 'imageFilter/updateFilter') {
        this.applyFilters();
      }
    });
  }

  private displayImage(file: File) {
    this.currentImageName = file.name;
    this.currentImage = '';
    previewImage(file).then(image => this.currentImage = image);
  }

  private applyFilters() {
    const currentFilter = this.filters[this.currentImageName];
    this.imageFilter = currentFilter ? currentFilter.stringify() : '';
  }

  private isDragAndDropAvailable(): boolean {
    const div = document.createElement('div');
    return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))
      && 'FormData' in window
      && 'FileReader' in window;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/image-filter/image-editor/image-viewer/image-viewer.vue